import ConstantComponent from './config.component';

// Load Constant variable component

//const Config = ConstantComponent["development"];
const Config = ConstantComponent[process.env.NODE_ENV];

export const Process = ConstantComponent["process"]

export default Config;
